import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "hooks/redux";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function Loader() {
  const uiStore = useAppSelector(store => store.uiStore);
  const { t } = useTranslation();
  if (!uiStore.loading) {
    return null;
  }
  return (
    <div className="loader_container">
      <div className="loader_content">
        <div className="loader">
          <FontAwesomeIcon icon={["far", "spinner-third"]} spin size="lg" />
          <p>{t("Loading...")}</p>
        </div>
      </div>
    </div>
  );
}
